import React from 'react';
import { v4 } from 'uuid';
import { PropTypes } from 'prop-types';
import EmptyPage from '~/pages/EmptyPage';
import * as S from './styles';
import getEvent from './utils/getEvent';

const TimelineItem = ({
  label,
  secondLabel,
  time,
  type,
  isLocal,
  competition,
}) => {
  const tooltipText = getEvent(type).text;

  return (
    <S.TimelineItem isLocal={isLocal}>
      <S.TimelineLabel>
        <S.Tooltip isLocal={isLocal} competition={competition}>
          <S.TimelineLabelIcon
            name={getEvent(type).icon}
            size={23}
            color="white"
          />
          <S.Label>{label}</S.Label>
          {secondLabel && <S.Label>{secondLabel}</S.Label>}
          {tooltipText && (
            <span className="tooltip">{getEvent(type).text}</span>
          )}
        </S.Tooltip>
        <S.Line />
      </S.TimelineLabel>
      <S.TimelineTime>
        {time}
        <span>&apos;</span>
      </S.TimelineTime>
    </S.TimelineItem>
  );
};

TimelineItem.propTypes = {
  label: PropTypes.string,
  secondLabel: PropTypes.string,
  time: PropTypes.number,
  type: PropTypes.string,
  isLocal: PropTypes.bool,
  competition: PropTypes.number,
};

TimelineItem.defaultProps = {
  label: null,
  secondLabel: null,
  time: null,
  type: '',
  isLocal: false,
  competition: 0,
};

const Timeline = ({
  className,
  styles,
  data,
  homeTeamShield,
  awayTeamShield,
  homeTeamShieldBg,
  awayTeamShieldBg,
  homeTeam,
  eventsFailed,
  tabletMode,
  competition,
}) => {
  const dataReverse = data.slice().reverse();
  return (
    <S.Container {...styles} className={className} eventsFailed={eventsFailed}>
      {eventsFailed && <EmptyPage fit />}
      {!eventsFailed && (
        <>
          <S.ShieldBackground homeTeamShieldBg={homeTeamShieldBg} />
          <S.ShieldBackground awayTeamShieldBg={awayTeamShieldBg} />
          <S.Wrapper>
            <S.Header tabletMode={tabletMode}>
              {homeTeamShield && <S.Shield src={homeTeamShield} />}
              <S.Grow />
              {awayTeamShield && <S.Shield src={awayTeamShield} />}
            </S.Header>
            <S.TimelineList>
              {!dataReverse.length && (
                <S.EmptyDataText>
                  Todavía no existen eventos para este partido
                </S.EmptyDataText>
              )}
              {dataReverse.map(
                ({ playerName, time, type, teamId, playerOffName }) => {
                  return (
                    <TimelineItem
                      key={v4()}
                      label={playerName}
                      secondLabel={playerOffName}
                      time={time}
                      type={type}
                      isLocal={teamId === homeTeam.id}
                      competition={competition}
                    />
                  );
                }
              )}
            </S.TimelineList>
          </S.Wrapper>
        </>
      )}
    </S.Container>
  );
};

Timeline.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  data: PropTypes.array,
  homeTeamShield: PropTypes.string,
  awayTeamShield: PropTypes.string,
  homeTeamShieldBg: PropTypes.string,
  awayTeamShieldBg: PropTypes.string,
  homeTeam: PropTypes.object,
  awayTeam: PropTypes.object,
  eventsFailed: PropTypes.bool,
  tabletMode: PropTypes.bool,
  competition: PropTypes.number,
};

Timeline.defaultProps = {
  className: null,
  styles: null,
  data: [],
  homeTeamShield: null,
  awayTeamShield: null,
  homeTeamShieldBg: null,
  awayTeamShieldBg: null,
  homeTeam: null,
  awayTeam: null,
  eventsFailed: false,
  tabletMode: false,
  competition: 0,
};

export default Timeline;
